import { WarningIcon } from '@moia-dev/pace-icons'
import { Button } from '@moia-dev/pace-web'
import { useTranslation } from 'react-i18next'

export const EmergencyButton = ({ disabled = false }) => {
  const { t } = useTranslation()

  return (
    <Button
      label={t('adFleetMap_EmergencyStop_label')}
      onClick={() => {}}
      size="default"
      variant="critical"
      disabled={disabled}
      icon={<WarningIcon />}
      css={theme => ({
        border: disabled
          ? `1px solid ${theme.semantic.ColorCriticalDisabled} !important`
          : `1px solid ${theme.semantic.ColorCriticalContrast} !important`,
        outline: disabled
          ? `${theme.semantic.ColorCriticalDisabled} !important`
          : `${theme.semantic.ColorCriticalContrast} !important`,
        background: disabled
          ? `${theme.semantic.ColorCriticalAlternative} !important`
          : `${theme.semantic.ColorCriticalAlternative} !important`,
        color: disabled
          ? `${theme.semantic.ColorCriticalDisabled} !important`
          : `${theme.semantic.ColorCriticalContrast} !important`,
        '&:hover': disabled
          ? undefined
          : {
              border: `1px solid ${theme.semantic.ColorCriticalHovered} !important`,
              outline: `${theme.semantic.ColorCriticalHovered} !important`,
              background: `${theme.semantic.ColorCriticalAlternative} !important`,
              color: `${theme.semantic.ColorCriticalHovered} !important`,
            },
      })}
    />
  )
}
